import Brain from "@/components/Icons/Brain";
import Chemistry from "@/components/Icons/Chemistry";
import Microscope from "@/components/Icons/Microscope";
import Chip from "@/components/Icons/Chip";
import MechEng from "@/components/Icons/MechEng";
import Terminal from "@/components/Icons/Terminal";

/* ------------------------------------------------------------------------------------ */

export default function WhatNeedsDoing() {
	return (
		<section className="sponsor-section">
			<header>
				<h2>What needs doing</h2>
				<p>Building blocks for brain emulation</p>
			</header>

			<ol>
				<li className="card">
					<header className="accent-blue">
						<h3>Software & Computing</h3>
						<div className="card-icon-container accent-blue-a15">
							<Terminal size={27} />
						</div>
					</header>

					<ul>
						<li>
							<h4>Connectomics ML & computer vision</h4> → auto-segment EM
							slices, detect synapses, spot errors.
						</li>
						<li>
							<h4>Large-scale neural simulation</h4> → turn wiring diagrams into
							spiking models on GPU/HPC clusters.
						</li>
						<li>
							<h4>Neuro-data engineering</h4> → build petabyte data stores,
							versioned atlases, interactive viewers.
						</li>
					</ul>
				</li>

				<li className="card">
					<header className="accent-blue-85">
						<h3>Electrical & Computer Engineering</h3>
						<div className="card-icon-container accent-blue-a15">
							<Chip size={27} />
						</div>
					</header>

					<ul>
						<li>
							<h4>Custom ASIC / neuromorphic hardware</h4> → create
							memory-centric chips for brain-scale models.
						</li>
						<li>
							<h4>High-bandwidth data-acquisition boards</h4> → stream terabytes
							from microscopes with minimal loss.
						</li>
					</ul>
				</li>

				<li className="card">
					<header className="accent-blue-90">
						<h3>Mechanical Engineering & Robotics</h3>
						<div className="card-icon-container accent-blue-a15">
							<MechEng size={27} />
						</div>
					</header>

					<ul>
						<li>
							<h4>Ultramicrotomy & sectioning robots</h4> → slice brain tissue
							at 30–40 nm reliably, 24/7.
						</li>
						<li>
							<h4>Precision mechatronics</h4> → build vibration-isolated stages
							for multi-beam microscopes.
						</li>
					</ul>
				</li>

				<li className="card">
					<header className="accent-pink-90">
						<h3>Physics & Imaging Technology</h3>
						<div className="card-icon-container accent-pink-a15">
							<Microscope size={27} />
						</div>
					</header>

					<ul>
						<li>
							<h4>Ultra-high-resolution EM / X-ray nano-CT</h4> → push voxel
							size lower, speed higher.
						</li>
						<li>
							<h4>Beam-optics & detector physics</h4> → design lenses, stages,
							and sensors for next-gen microscopes.
						</li>
					</ul>
				</li>

				<li className="card">
					<header className="accent-pink-85">
						<h3>Chemistry & Materials Science</h3>
						<div className="card-icon-container accent-pink-a15">
							<Chemistry size={27} />
						</div>
					</header>

					<ul>
						<li>
							<h4>Conductive & protective coatings</h4> → ensure samples survive
							long imaging runs without charging.
						</li>
						<li>
							<h4>Novel stains & contrast agents</h4> → highlight specific
							synaptic proteins for easier ML detection.
						</li>
					</ul>
				</li>

				<li className="card">
					<header className="accent-pink">
						<h3>Biology & Neuroscience</h3>
						<div className="card-icon-container accent-pink-a15">
							<Brain size={27} />
						</div>
					</header>

					<ul>
						<li>
							<h4>Tissue preservation & staining</h4> → devise
							fixation/protocols that keep ultrastructure intact.
						</li>
						<li>
							<h4>Neuroanatomy & synapse mapping</h4> → validate
							reconstructions, ground-truth datasets, curate atlases.
						</li>
						<li>
							<h4>Comparative neurobiology</h4> → collect reference data across
							species to sanity-check emulations.
						</li>
					</ul>
				</li>
			</ol>
		</section>
	);
}
